module.exports = __webpack_public_path__ + "img/Fondo-blanco-escritorio.305ea6e9.png";